const navigation = {
  items: [
    {
      name: "Consultas",
      url: "/dashboard",
      icon: "fa fa-tachometer",
      children: [
        {
          name: "Análisis de Medicamentos",
          url: "/dashboard/medicines-analisys",
          icon: "fa fa-area-chart",
          permission: "dashboard_medicines-analysis",
        },
        {
          name: "Alertas de Consumo Irregular",
          url: "/dashboard/irregular-consumption-alerts",
          icon: "fa fa-bell",
          permission: "dashboard_irregular-consumption-alerts",
        },
        {
          name: "Análisis de Reclamaciones",
          url: "/dashboard/claims-analysis",
          icon: "fa fa-line-chart",
          permission: "dashboard_claims-analysis",
        },
        {
          name: "Entrega de Reclamaciones",
          url: "/dashboard/delivery-of-claims",
          icon: "fa fa-inbox",
          permission: "dashboard_delivery-of-claims",
        },
        {
          name: "Flujo de Autorización",
          url: "/dashboard/authorization-inquiry",
          icon: "fa fa-sitemap",
          permission: "dashboard_authorization-inquiry",
        },
        {
          name: "Reportes de Autorizaciones",
          url: "/dashboard/authorization-reports",
          icon: "fa fa-list-alt",
          permission: "dashboard_authorization-reports",
        },
        {
          name: "Historial de Afiliado",
          url: "/dashboard/affiliate-history",
          icon: "fa fa-address-card-o",
          permission: "dashboard_hitorical-affiliate",
        },
        {
          name: "Recetas de Pre-Autorizaciones",
          url: "/dashboard/pre-auth-history",
          icon: "fa fa-history",
          permission: "dashboard_historical-pre-auth",
        },
        {
          name: "Pre-Autorizaciones",
          url: "/dashboard/pre-authorization-history",
          icon: "fa fa-check-square-o",
          permission: "dashboard_pre-authorization-history",
        },
        {
          name: "Medicamentos",
          url: "/dashboard/consult-medications",
          icon: "fa fa-medkit",
          permission: "dashboard_consult-medication",
        },
        {
          name: "Monitoreo de Auditoría",
          url: "/dashboard/audit-performance",
          icon: "fa fa-pie-chart",
          permission: "dashboard_audit-performance",
        },
        {
          name: "Planes de P&P",
          url: "/dashboard/consult-pyp",
          icon: "fa fa-calendar-check-o",
          permission: "dashboard_consult-pyp",
        },
        {
          name: "Recetas Digitales",
          url: "/dashboard/electronic-recipes/affiliate/search",
          activePath: "/dashboard/electronic-recipes",
          icon: "fa fa-mobile",
          permission: "dashboard_electronic-recipes",
        },
        {
          name: "Reclamaciones Improcedentes",
          url: "/dashboard/improper-claims",
          icon: "fa fa-exclamation-circle",
          permission: "dashboard_improper-claims",
        },
        {
          name: "Reclamaciones Objetadas",
          url: "/dashboard/claim-denied",
          icon: "fa fa-times-circle-o",
          permission: "dashboard_claim-denied",
        },
        {
          name: "Reclamaciones por Prestador",
          url: "/dashboard/consultation-claims-provider",
          icon: "fa fa-hospital-o",
          permission: "dashboard_consultation-claims-provider",
        },
      ],
    },
    {
      name: "Administración",
      url: "/administration",
      icon: "fa fa-cogs",
      children: [
        {
          name: "ARS",
          url: "/administration/arses",
          icon: "fa fa-heartbeat",
          permission: "administration_arses",
        },
        {
          name: "Canales",
          url: "/administration/channels",
          icon: "fa fa-th",
          permission: "administration_channels",
        },
        {
          name: "Catálogos de Estados",
          url: "/administration/status-catalogs",
          icon: "fa fa-tasks",
          permission: "administration_status-catalogs",
        },
        {
          name: "Entidad Jurídica",
          url: "/administration/legal-entity",
          icon: "fa fa-building",
          permission: "administration_legal-entity",
        },
        {
          name: "Parámetros Generales",
          url: "/administration/options",
          icon: "fa fa-pencil-square-o",
          permission: "administration_options",
        },
        {
          name: "Tipos de Recetas",
          url: "/administration/recipes-type",
          icon: "fa fa-server",
          permission: "administration_recipes-types",
        },
        {
          name: "Servicios de Recetas",
          url: "/administration/prescription-services",
          icon: "fa fa-medkit",
          permission: "administration_prescription-services",
        },
        {
          name: "Tipos de Solicitud Improcedentes",
          url: "/administration/request-coming",
          icon: "fa fa-tasks",
          permission: "administration_request-coming",
        },
        {
          name: "Tipos de Alerta",
          url: "/administration/alert-types",
          icon: "fa fa-exclamation-triangle",
          permission: "administration_alert_type",
        },
      ],
    },
    {
      name: "Operaciones",
      url: "/operations",
      icon: "fa fa-list-ul",
      children: [
        {
          name: "Adm. Pacientes P&P",
          url: "/operations/pyp-patient-management",
          icon: "fa fa-users",
          permission: "operations_pyp-patient-management",
        },
        {
          name: "Adm. Usuarios Call Center",
          url: "/operations/call-center-user-admin",
          icon: "fa fa-user-circle-o",
          permission: "operations_call-center-user-admin",
        },
        {
          name: "Auditoría de Reclamaciones",
          url: "/operations/claims-audit",
          icon: "fa fa-search",
          permission: "operations_claims-audit",
        },
        {
          name: "Autorizaciones Post Período Autorizado",
          url: "/operations/post-authorized",
          icon: "fa fa-file-text",
          permission: "operations_post-authorized",
        },
        {
          name: "Causas de Cancelación",
          url: "/operations/cancelation-reasons",
          icon: "fa fa-ban",
          permission: "operations_cancelation-reasons",
        },
        {
          name: "Causas de Objeción",
          url: "/operations/denial-reasons",
          icon: "fa fa-minus-circle",
          permission: "operations_denial-reasons",
        },
        {
          name: "Cierre Mensual",
          url: "/operations/monthly-closure",
          icon: "fa fa-calendar-times-o",
          permission: "operations_monthly-closure",
        },
        {
          name: "Entrega de Reclamaciones a ARS",
          url: "/operations/delivery-of-claims",
          icon: "fa fa-truck",
          permission: "operations_delivery-of-claims",
        },
        {
          name: "Modificación de Contraseñas",
          url: "/operations/password-modification",
          icon: "fa fa-lock",
          permission: "operations_password-modification",
        },
        {
          name: "Motivo de Pre-Autorizaciones",
          url: "/operations/reason-pre-authorization",
          icon: "fa fa-question-circle-o",
          permission: "operations_reason-pre-authorization",
        },
        {
          name: "Ofertas de Medicamentos",
          url: "/operations/offer-medicines",
          icon: "fa fa-medkit",
          permission: "operations_offer-medicines",
        },
        {
          name: "Prestadores",
          url: "/operations/pharmacy-providers",
          icon: "fa fa-hospital-o",
          permission: "operations_pharmacy-providers",
        },
        {
          name: "Pre-Autorizaciones",
          url: "/operations/recipes-pre-authorization",
          icon: "fa fa-check-square-o",
          permission: "operations_pre-authorization",
        },
        {
          name: "Recepción de Facturas",
          url: "/operations/invoice-receipt",
          icon: "fa fa-money",
          permission: "operations_invoice-receipt",
        },
        {
          name: "Reversión de NCF",
          url: "/operations/ncf-reversal",
          icon: "fa fa-history",
          permission: "operations_ncf-reversal",
        },
        {
          name: "Validación de Autorización",
          url: "/operations/authorization-validation",
          icon: "fa fa-check-circle-o",
          permission: "operations_authorization-validation",
        },
        {
          name: "Validación de Receta",
          url: "/operations/recipe-validation",
          icon: "fa fa-file-text-o",
          permission: "operations_recipe-validation",
        },
        {
          name: "Recogidas Sospechosas",
          url: "/operations/suspicious-pickup",
          icon: "fa fa-eye",
          permission: "operations_suspicious-pickups",
        },

        
      ],
    },
    {
      name: "Contabilidad",
      url: "/accounting",
      icon: "fa fa-calculator",
      children: [
        {
          name: "Administrador de NCF's",
          url: "/accounting/ncf",
          icon: "fa fa-barcode",
          permission: "accounting_admin-ncf",
        },
        {
          icon: "fa fa-file-word-o",
          name: "Comprobantes Fiscales",
          url: "/accounting/typetaxvouchers",
          permission: "accounting_typetaxvouchers",
        },
        {
          icon: "fa fa-tasks",
          name: "Estados de Facturación",
          url: "/accounting/billing-statuses",
          permission: "accounting_billing-statuses",
        },
        {
          icon: "fa fa-calculator",
          name: "Facturación",
          url: "/accounting/billing",
          permission: "accounting_billing",
        },
        {
          icon: "fa fa-file-code-o",
          name: "Documentos Electrónicos",
          url: "/accounting/electronic-documents",
          permission: "accounting_electronic-documents",
        },
        {
          icon: "fa fa-inbox",
          name: "Documentos Recibidos",
          url: "/accounting/received-documents",
          permission: "accounting_received-documents",
        },
        {
          icon: "fa fa-bank",
          name: "Bancos",
          url: "/accounting/banks",
          permission: "accounting_banks",
        },
        {
          icon: "fa fa-credit-card",
          name: "Método de Pago",
          url: "/accounting/payment-methods",
          permission: "accounting_payment-methods",
        },
        {
          icon: "fa fa-book",
          name: "Registro de Cobros",
          url: "/accounting/collection-record",
          permission: "accounting_collection-record",
        },
        {
          icon: "fa fa-address-book-o",
          name: "Registro de Contribuyentes",
          url: "/accounting/taxpayer-registry",
          permission: "operations_taxpayer_registry",
        },
        {
          name: "Períodos de Facturación",
          url: "/accounting/billing-periods",
          icon: "fa fa-calendar",
          permission: "accounting_billing_periods",
        },
      ],
    },
    {
      name: "Medicamentos",
      url: "/medicines",
      icon: "fa fa-medkit",
      children: [
        {
          name: "Actualización de Precio",
          icon: "fa fa-usd",
          url: "/medicines/price-update",
          permission: "medicine_price-update",
        },
        {
          name: "Clasificación Terapéutica",
          icon: "fa fa-th-list",
          url: "/medicines/therapeutic-classification",
          permission: "medicine_therapeutic-classification",
        },
        {
          name: "Medicamentos",
          icon: "fa fa-plus-square",
          url: "/medicines",
          permission: ["medicine_medicines"],
          children: [
            {
              name: "Línea",
              url: "/medicines/lines",
              permission: "medicine_lines",
              icon: "fa fa-long-arrow-right",
            },
            {
              name: "Medicamentos",
              icon: "fa fa-medkit",
              url: "/medicines/medicines",
              permission: "medicine_medicines",
            },
          ],
        },
        {
          name: "Parámetros Medicamentos",
          icon: "fa fa-sliders",
          url: "/medicines",
          permission: "medicine_contents",
          children: [
            {
              name: "Combinaciones No Detallables",
              icon: "fa fa-clone",
              url: "/medicines/non-detailable-medicine",
              permission: "medicine_non-detailable-medicine",
            },
            {
              name: "Concentración",
              icon: "fa fa-connectdevelop",
              url: "/medicines/concentrations",
              permission: "medicine_contents",
            },
            {
              name: "Contenido",
              icon: "fa fa-flask",
              url: "/medicines/contents",
              permission: "medicine_contents",
            },
            {
              name: "Empaque",
              icon: "fa fa-archive",
              url: "/medicines/packings",
              permission: "medicine_packings",
            },
            {
              name: "Formas",
              icon: "fa fa-cubes",
              url: "/medicines/forms",
              permission: "medicine_forms",
            },
            {
              name: "Sabores",
              icon: "fa fa-lemon-o",
              url: "/medicines/flavors",
              permission: "medicine_flavors",
            },

            {
              name: "Moléculas",
              icon: "fa fa-chain",
              url: "/medicines/molecules",
              permission: "medicine_molecules",
            },
            {
              name: "Unidad de Concentración",
              icon: "fa fa-braille",
              url: "/medicines/concentration-units",
              permission: "medicine_concentration-units",
            },
            {
              name: "Unidad de Contenido",
              icon: "fa fa-tint",
              url: "/medicines/content-units",
              permission: "medicine_content_unit",
            },
          ],
        },
      ],
    },
    {
      name: "Licitaciones",
      url: "/tenders",
      icon: "fa fa-envelope-open-o",
      children: [
        {
          name: "Administración de Licitaciones",
          url: "/tenders/tender-admin",
          icon: "fa fa-envelope-square",
          permission: "tenders_admin-tenders",
        },
        {
          name: "Comisiones de Licitaciones",
          url: "/tenders/tender-commissions",
          icon: "fa fa-money",
          permission: "tenders_tender-commissions",
        },
        {
          name: "Proveedores de Medicamentos",
          url: "/tenders/meds-providers",
          icon: "fa fa-user-md",
          permission: "tenders_medicines-providers",
        },
        {
          name: "Registro de Licitaciones",
          url: "/tenders/tenders-record",
          icon: "fa fa-envelope-o",
          permission: "tenders_registration-tenders",
        },
        {
          name: "Registro de Proveedores",
          url: "/tenders/supplier",
          icon: "fa fa-id-card",
          permission: "tenders_supplier-registration",
        },
      ],
    },
    {
      name: "Gestión Humana",
      url: "/hmanagement",
      icon: "fa fa-user-o",
      children: [
        {
          name: "Perfiles",
          url: "/hmanagement/profile",
          icon: "fa fa-users",
          permission: "hmanagement_profile",
        },
        {
          name: "Usuarios",
          url: "/hmanagement/user",
          icon: "fa fa-user",
          permission: "hmanagement_user",
        },
        {
          name: "Opciones de Módulo",
          url: "/hmanagement/module-options",
          icon: "fa fa-th-list",
          permission: "hmanagement_module-options",
        },
      ],
    },
    {
      name: "Consultorio Médico",
      url: "/patient-management",
      icon: "fa fa-user-md",
      children: [
        {
          name: "Alergias",
          icon: "fa fa-ban",
          url: "/patient-management/allergies",
          permission: "patient-management_allergies",
        },
        {
          name: "Tipos de Licencias Médicas",
          url: "/patient-management/medical-licenses",
          icon: "fa fa-file-text-o",
          permission: "patient-management_medical_licenses",
        },
        {
          icon: "fa fa-user-md",
          name: "Médicos",
          url: "/patient-management/mstaffs",
          permission: "hmanagement_mstaff",
        },
        {
          icon: "fa fa-users",
          name: "Usuarios de Cuentas",
          url: "/patient-management/account-users",
          permission: "patient-management_account-users",
        },
        {
          name: "Paquetes de Recetarios",
          url: "/patient-management/prescription-packages",
          icon: "fa fa-archive",
          permission: "patient-management_prescription-packages",
        },
        {
          name: "Pacientes",
          icon: "fa fa-address-book",
          url: "/patient-management/patients",
          permission: "operation_patients",
        },
        {
          name: "Tipos de Citas Médicas",
          url: "/patient-management/appointment-medical",
          icon: "fa fa-calendar",
          permission: "patient-management_appointment_medical",
        },
        {
          name: "Servicios de Salud",
          url: "/patient-management/health-services",
          icon: "fa fa-medkit",
          permission: "patient-management_health_services",
        },
        {
          name: "Parámetros Médicos - Administración",
          url: "/patient-management/medical-parameters",
          icon: "fa fa-heartbeat",
          permission: "patient-management_medical_parameters",
        },
        {
          name: "Parámetros Médicos - Grupos",
          url: "/patient-management/parameter-group",
          icon: "fa fa-sliders",
          permission: "patient-management_parameter_group",
        },
        {
          name: "Tipo de Servicio de Salud",
          url: "/patient-management/product-types",
          icon: "fa fa-th",
          permission: "patient-management_products-types",
        },
        {
          name: "Especialidades Médicas",
          url: "/patient-management/medical-specialties",
          icon: "fa fa-stethoscope",
          permission: "patient-management_medical-specialties",
        },
      ],
    },
  ],
};

export default navigation;
